import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n      & {\n        border-color: ", ";\n      }\n    "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n      & {\n        border-color: ", ";\n      }\n    "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n      & {\n        border-color: ", ";\n      }\n    "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n        & {\n          width: ", "px;\n          height: ", "px;\n        }\n      "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n        & {\n          width: ", "px;\n          height: ", "px;\n        }\n      "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n        & {\n          width: ", "px;\n          height: ", "px;\n        }\n      "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n      & {\n        width: ", "px;\n        height: ", "px;\n      }\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  animation: 1s linear infinite ", ";\n  display: inline-block;\n\n  width: ", "px;\n  height: ", "px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  border-radius: 50%;\n  border: 0.2rem solid transparent;\n  border-left-color: transparent !important;\n  border-color: ", ";\n  ", ";\n  /* Soft */\n  ", "\n\n  /* Reverse */\n  ", "\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n\t0% {\n    transform: rotate(0deg);\n  } \n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      &&& {\n        color: transparent !important;\n        cursor: progress !important;\n      }\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      & {\n        background-image: url(", ") !important;\n        background-position: center;\n        background-size: cover;\n      }\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n            & {\n              border-color: ", ";\n              color: ", ";\n              &:hover,\n              &:focus {\n                background-color: ", ";\n              }\n              &:disabled {\n                border-color: ", " !important;\n                color: ", " !important;\n              }\n            }\n          "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n            & {\n              border-color: ", ";\n              color: ", ";\n              &:hover,\n              &:focus {\n                background-color: ", ";\n              }\n            }\n          "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n            & {\n              border-color: ", ";\n              color: ", ";\n              &:hover,\n              &:focus {\n                background-color: ", ";\n              }\n            }\n          "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n            & {\n              border-color: ", ";\n              color: ", ";\n              &:hover,\n              &:focus {\n                background-color: ", ";\n              }\n            }\n          "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      & {\n        color: ", ";\n        background-color: transparent;\n        background-image: none;\n        border-style: solid;\n        border-width: 2px;\n        border-color: ", ";\n        &:hover,\n        &:focus {\n          background-color: ", ";\n        }\n\n        &:disabled {\n          border-color: ", " !important;\n          background-color: transparent !important;\n          color: ", " !important;\n        }\n\n        ", ";\n\n        ", ";\n\n        ", ";\n\n        ", ";\n      }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      & {\n        color: ", ";\n        &:disabled {\n          background-color: ", " !important;\n          color: ", " !important;\n        }\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      & {\n        color: ", ";\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      & {\n        background-color: ", ";\n        &:hover,\n        &:focus {\n          background-color: ", ";\n        }\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      width: auto;\n      min-width: 160px;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      & {\n        width: 100%;\n        ", ";\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  font-family: ", ";\n  font-weight: 600;\n  box-sizing: border-box;\n  cursor: pointer;\n  vertical-align: middle;\n  user-select: none;\n  text-decoration: none;\n  border-radius: 6px;\n  border: none;\n  outline: none;\n  line-height: 1;\n\n  [data-start],\n  [data-end] {\n    display: inline-flex;\n  }\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n\n  transition: background-color 180ms ease-in-out;\n\n  background-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n  }\n\n  ", ";\n\n  &:disabled {\n    cursor: not-allowed;\n    background-image: none !important;\n    background-color: ", " !important;\n    color: ", " !important;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import styled, { css, keyframes } from "styled-components";
import { font, media, button } from "../Utils/Constants";
export var colors = {
  primary: ["branding", "primary"],
  secondary: ["branding", "secondary"],
  success: ["action", "success"],
  danger: ["action", "danger"],
  warning: ["action", "warning"],
  info: ["action", "info"],
  soft: ["action", "soft"],
  reverse: ["action", "reverse"]
};
export var BUTTON_SIZES = {
  xs: ["xs", "xs", "xs", "xs"],
  s: ["s", "s", "s", "s"],
  m: ["m", "m", "m", "m"],
  l: ["l", "l", "l", "l"],
  xl: ["xl", "xl", "xl", "xl"]
};
var loaderSizes = {
  xl: 26,
  l: 24,
  m: 20,
  s: 16,
  xs: 12
};

var ButtonComponent = function ButtonComponent(_ref) {
  var start = _ref.start,
      end = _ref.end,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "m" : _ref$size,
      sizes = _ref.sizes,
      children = _ref.children,
      forwardRef = _ref.forwardRef,
      isLoading = _ref.isLoading,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["start", "end", "size", "sizes", "children", "forwardRef", "isLoading", "disabled"]);

  var _ref2 = colors[props.color] || [null, null],
      _ref3 = _slicedToArray(_ref2, 2),
      group = _ref3[0],
      color = _ref3[1];

  var buttonSizes = sizes || BUTTON_SIZES[size] || BUTTON_SIZES["m"];
  return React.createElement(StyledButton, _extends({}, props, {
    sizes: buttonSizes,
    group: group,
    color: color,
    disabled: isLoading || disabled,
    isloading: isLoading,
    ref: forwardRef
  }), start && React.createElement("span", {
    "data-start": true
  }, start), isLoading && React.createElement(CircleLoader, {
    sizes: buttonSizes,
    group: group,
    color: color
  }), children, end && React.createElement("span", {
    "data-end": true
  }, end));
};

var Button = React.forwardRef(function (props, ref) {
  return React.createElement(ButtonComponent, _extends({
    forwardRef: ref
  }, props));
});
export default Button;
export var StyledButton = styled.button(_templateObject(), font("text"), function (props) {
  return props.sizes[0] && button(props.sizes[0]);
}, media.greaterThan("tablet")(_templateObject2(), function (props) {
  return props.sizes[1] && button(props.sizes[1]);
}), media.greaterThan("desktop")(_templateObject3(), function (props) {
  return props.sizes[2] && button(props.sizes[2]);
}), media.greaterThan("wide")(_templateObject4(), function (props) {
  return props.sizes[3] && button(props.sizes[3]);
}), function (props) {
  return props.full && css(_templateObject5(), media.greaterThan("tablet")(_templateObject6()));
}, function (props) {
  return props.theme.color("branding", "primary");
}, function (props) {
  return props.theme.color("text", "light");
}, function (props) {
  return props.theme.color("branding", "primary:hover");
}, function (props) {
  return props.color && css(_templateObject7(), props.theme.color(props.group, props.color), props.theme.color(props.group, "".concat(props.color, ":hover")));
}, function (props) {
  return props.theme.color("action", "soft");
}, function (props) {
  return props.theme.color("text", "tertiary");
}, function (props) {
  return props.color === "soft" && css(_templateObject8(), props.theme.color("text", "primary"));
}, function (props) {
  return props.color === "reverse" && css(_templateObject9(), props.theme.color("text", "primary"), function (props) {
    return props.theme.color("action", "dark");
  }, function (props) {
    return props.theme.color("text", "tertiary");
  });
}, function (props) {
  return props.outline && css(_templateObject10(), props.theme.color("branding", "primary"), props.theme.color("branding", "primary"), props.theme.color("branding", "primary:10"), props.theme.color("action", "soft"), props.theme.color("text", "tertiary"), function (props) {
    return props.color && css(_templateObject11(), props.theme.color(props.group, props.color), props.theme.color(props.group, props.color), props.theme.color(props.group, "".concat(props.color, ":10")));
  }, function (props) {
    return props.color === "secondary" && css(_templateObject12(), props.theme.color("border", "primary"), props.theme.color("text", "primary"), props.theme.color("action", "soft"));
  }, function (props) {
    return props.color === "soft" && css(_templateObject13(), props.theme.color("action", "soft"), props.theme.color("text", "primary"), props.theme.color("action", "soft"));
  }, function (props) {
    return props.color === "reverse" && css(_templateObject14(), props.theme.color("action", "reverse"), props.theme.color("text", "light"), props.theme.color("action", "soft"), props.theme.color("action", "dark"), function (props) {
      return props.theme.color("text", "tertiary");
    });
  });
}, function (props) {
  return props.image && css(_templateObject15(), props.image);
}, function (props) {
  return props.isloading && css(_templateObject16());
});
var loaderAnimation = keyframes(_templateObject17());
var CircleLoader = styled.div(_templateObject18(), loaderAnimation, loaderSizes["m"], loaderSizes["m"], function (props) {
  return props.sizes[0] && css(_templateObject19(), function (props) {
    return loaderSizes[props.sizes[0]];
  }, function (props) {
    return loaderSizes[props.sizes[0]];
  });
}, media.greaterThan("tablet")(_templateObject20(), function (props) {
  return props.sizes[1] && css(_templateObject21(), function (props) {
    return loaderSizes[props.sizes[1]];
  }, function (props) {
    return loaderSizes[props.sizes[1]];
  });
}), media.greaterThan("desktop")(_templateObject22(), function (props) {
  return props.sizes[2] && css(_templateObject23(), function (props) {
    return loaderSizes[props.sizes[2]];
  }, function (props) {
    return loaderSizes[props.sizes[2]];
  });
}), media.greaterThan("wide")(_templateObject24(), function (props) {
  return props.sizes[3] && css(_templateObject25(), function (props) {
    return loaderSizes[props.sizes[3]];
  }, function (props) {
    return loaderSizes[props.sizes[3]];
  });
}), function (props) {
  return props.theme.color("branding", "primary");
}, function (props) {
  return props.color && css(_templateObject26(), props.theme.color(props.group, props.color));
}, function (props) {
  return props.color === "soft" && css(_templateObject27(), props.theme.color("text", "primary"));
}, function (props) {
  return props.color === "reverse" && css(_templateObject28(), props.theme.color("text", "light"));
});